import React, { PropTypes } from "react";
import Toggle from "react-toggle";

class MemberCoverageBlockWithdrawal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const isBlockedFromWithdrawal = event.target.checked;
    const memberCoverage = {
      ...this.props.memberCoverage,
      isBlockedFromWithdrawal,
    };

    this.props.onSubmit({ memberCoverage });
  }

  render() {
    return (
      <label className="block-coverage-withdrawal">
        <Toggle
          defaultChecked={this.props.memberCoverage.isBlockedFromWithdrawal}
          icons={{
            checked: <span className="icon icon-checkmark" />,
            unchecked: null,
          }}
          onChange={this.handleChange}
        />
      </label>
    );
  }
}

MemberCoverageBlockWithdrawal.propTypes = {
  dataActions: PropTypes.object,
  memberCoverage: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default MemberCoverageBlockWithdrawal;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/MemberCoverageBlockWithdrawal.js